import { createRotulo } from './Rotulo'

export class Servico {
  constructor ({
    id,
    codigo,
    nome,
    categoria_id,
    unidade_id,
    descricao,
    imagens,
  } = {
    id: '',
    codigo: '',
    nome: '',
    categoria_id: '',
    unidade_id: '',
    descricao: '',
    imagens: [],
  }) {
    this.id = id
    this.codigo = codigo
    this.nome = nome
    this.categoria_id = categoria_id
    this.unidade_id = unidade_id
    this.descricao = descricao
    this.imagens = imagens
  }
}

export function createServico ({ rotulo, ...data }) {
  return Object.freeze(new Servico({ rotulo: createRotulo(rotulo), ...data }))
}
